(function () {
    angular.module('ngmvac').controller('ListPageController', ListPageController);
    ListPageController.$inject = ['$scope', '$window', '$filter', '$timeout', '$sce', 'HotelFactory', 'ContentApiService', 'DatosCotizador', 'variablesService', 'timeService', 'paginationService', 'groupedProperties', 'orderByFilter', 'CurrencyDictionary', '$rootScope', 'fontNames', '$location', '$log'];

    function ListPageController($scope, $window, $filter, $timeout, sce, HotelFactory, ContentApiService, DatosCotizador, variablesService, timeService, paginationService, groupedProperties, orderBy, CurrencyDictionary, $rootScope, fontNames, $location, $log) {
        var vm = this;
        /*  Variables del scope */
        vm.step = 2;
        // Rutas
        vm.pathImages = variablesService.pathImages;
        vm.pathImagesMedium = variablesService.pathImagesMedium;
        vm.pathImagesBigger = variablesService.pathImagesBigger;

        vm.tabSelected = -1;
        vm.tabs = [false, false, false, false];
        vm.openingTab = false;
        vm.codeHotel;
        vm.imgApihotel;
        // Lista de hoteles
        vm.hoteles = [];
        vm.viewHoteles = [];

        vm.fasPrimaryFront = [];

        vm.boardFilters = [];
        vm.unirfiltros = fnUnirfiltros;
        //room
        vm.numroom = 0;
        // Opciones para el filtro Ordenar por (input select)
        vm.filterSelect = {
            availableOptions: [{
                id: 1,
                name: 'Recomendación'
            },
            {
                id: 2,
                name: 'Tarifa Menor a Mayor'
            }, {
                id: 3,
                name: 'Tarifa Mayor a Menor'
            }, {
                id: 4,
                name: 'Estrellas Menor a Mayor'
            }, {
                id: 5,
                name: 'Estrellas Mayor a Menor'
            }
            ],
            selectedOption: {
                id: 2,
                name: 'Tarifa Menor a Mayor'
            }
        };
        vm.OrdeIn = 0;
        // Cotizador
        vm.initialStay = {
            checkIn: moment().add(4, 'days').format('YYYY-MM-DD'),
            checkOut: moment().add(7, 'days').format('YYYY-MM-DD')
        };

        vm.initialStay2021 = {
            checkIn: moment("20210101").add(4, 'days').format('YYYY-MM-DD'),
            checkOut: moment("20210101").add(5, 'days').format('YYYY-MM-DD')
        };
        vm.setInitialStay2021 = false;

        if(moment("20210101").diff(moment(), 'days') > 0){
            vm.setInitialStay2021 = true;
        }

        vm.formatfecha = function (valorfecha) {
            if (valorfecha != undefined) {
                var arrayfechas = valorfecha.split('-');
                switch (arrayfechas[1]) {
                    case '01':
                        vm.messtring = 'Ene.';
                        break;
                    case '02':
                        vm.messtring = 'Feb.';
                        break;
                    case '03':
                        vm.messtring = 'Mar.';
                        break;
                    case '04':
                        vm.messtring = 'Abr.';
                        break;
                    case '05':
                        vm.messtring = 'May.';
                        break;
                    case '06':
                        vm.messtring = 'Jun.';
                        break;
                    case '07':
                        vm.messtring = 'Jul.';
                        break;
                    case '08':
                        vm.messtring = 'Ago.';
                        break;
                    case '09':
                        vm.messtring = 'Sep.';
                        break;
                    case '10':
                        vm.messtring = 'Oct.';
                        break;
                    case '11':
                        vm.messtring = 'Nov.';
                        break;
                    case '12':
                        vm.messtring = 'Dic.';
                        break;
                }
                return arrayfechas[2] + ' ' + vm.messtring + ' ' + arrayfechas[0]
            } else {
                return valorfecha;
            }
        };
        vm.galleryOpeneds = []
        vm.stay = {};
        vm.disponibilidad = false;
        vm.destination = {};
        vm.display = "block";
        vm.initializationData = {};
        vm.selectedHotel;
        // Modal 
        vm.showModal = false;
        vm.showModalMap = false;
        vm.modalPathActual = "";
        // Paginador
        vm.countClicked = 1;
        vm.numPags = 0;
        vm.itemsPerPage = 10;
        // Timer
        vm.timeExpired = false;
        // Variables de usuarios
        vm.uidFenix = $('#uidFenix').val();
        vm.anim = 0;
        var zonas = ['Todas'];
        vm.searchText = ''; // REVISAR
        vm.searchTextTemp = '';
        vm.loadComplete = false;
        vm.roomsInfo = variablesService.roomsInfo;
        //Valores predeterminados
        vm.selectParams = variablesService.selectParams;
        vm.alojamiento = angular.copy(variablesService.alojamiento);
        vm.starFilter = variablesService.starFilter;
        vm.radiostartBoar = "";
        vm.startView = [];
        vm.radiostartboardCode = "";
        vm.alojamientoSeleccionado = 'Todas';
        vm.zonaSeleccionada = 'Todas';
        $scope.showSliderFilter = true;
        //Variables Facilidades
        vm.MostrarFacilidades = "";
        vm.ListFacilidades = {};
        vm.cont = 0;
        $("#ContFacilities").hide();

        vm.cotizadorSeleccionado = localStorage.getItem('cotizadorSeleccionado');

        // Flags utilizados en los Ajax de hoteles y API

        $scope.hbRS = false;
        $scope.reverse = true;
        vm.activatedView = 1;
        vm.views = [
            '#listaCollapse',
            '#filtros',
            '#orderByCollapse',
            '#cotizadorCollapse'
        ];
        vm.ordenView = {
            type: 1,
            order: 0
        };

        if (vm.step) {
            $('.footer-mvac').hide();
            $('.footer-panel-header').hide();
        }

        vm.reloadRoute = function(){
            window.location.reload(true);
        }

        // TODO: eliminar


        $scope.$watchGroup(['hbRS'], function (newValues) {
            console.log(newValues[0])
            if(!newValues[0]){
                setTimeout(() => {
                    $("#mask-ten").fadeOut('slow');
                }, 2000);
            }

            if (newValues[0]) {
                $("#mask-ten").fadeOut('slow');

                if (vm.step == 2) {

                    vm.loadComplete = true;

                    var hotels = angular.copy(vm.viewHoteles);
                    var bf = groupedProperties.getGroupedProperty($filter('boardPackagesFilter')(hotels), ['boardCode'], ['boardCode', 'boardName', 'count'], true);

                    ContentApiService.getAllAccomodation().then(function (response) {
                        angular.forEach(hotels, function (hotel) {
                            angular.forEach(response.data, function (alojamiento) {
                                angular.forEach(alojamiento.codes, function (code) {
                                    if (hotel.categoryCode == code) {
                                        var alojExist = false;
                                        angular.forEach(vm.alojamiento, function (aloja) {
                                            if (aloja == 'Pendiente Categoria') aloja = 'Sin categoría';
                                            if (aloja === alojamiento.nombre) {
                                                alojExist = true;
                                            }
                                        });
                                        if (!alojExist) {
                                            vm.alojamiento.push(alojamiento.nombre);
                                        }
                                    }
                                });
                            });
                        });
                    }).catch(function (response) { });

                    vm.boardFilters = bf;
                    $scope.numhoteles = hotels.length;
                    $scope.conteofiltros = $filter('conteoParaFiltros')(hotels);

                    vm.totalNoches = moment(vm.initializationData.stay.checkOut, 'YYYY-MM-DD').diff(moment(vm.initializationData.stay.checkIn, 'YYYY-MM-DD'), 'days');
                    vm.zonas = zonas;
                    vm.zonaSeleccionada = 'Todas';
                    vm.numroom = vm.viewHoteles[0].minPackage.nHabitaciones;

                }
            }
        });
        //** Obtenemos los datos cotizados

        vm.cotizador = HotelFactory.getCotizador();
        fnSetCotizadorData(vm.cotizador);


        // HotelFactory.checkPreviusAvailability(vm.step).then(function (response) {
        //     switch (response.status) {
        //         case 204:
        //             loader('none');
        //             break;
        //         default:

        //             angular.forEach(response.data.hotels, function (hotel) {
        //                 if (hotel.hasOwnProperty('content')) {
        //                     if (hotel.content.hasOwnProperty('facilities')) {
        //                         angular.forEach(hotel.content.facilities, function (fas) {
        //                             if (fas.facilityCode == 261) {
        //                                 vm.fasPrimaryFront.push({
        //                                     hotelcode: hotel.code,
        //                                     description: fas.description.content,
        //                                     class: 'fas fa-wifi'
        //                                 });
        //                             }
        //                             if (fas.facilityCode == 200 && fas.facilityGroupCode == 71) {
        //                                 vm.fasPrimaryFront.push({
        //                                     hotelcode: hotel.code,
        //                                     description: fas.description.content,
        //                                     class: 'fas fa-utensils'
        //                                 });
        //                             }
        //                             if (fas.facilityCode == 470 && fas.facilityGroupCode == 70) {
        //                                 vm.fasPrimaryFront.push({
        //                                     hotelcode: hotel.code,
        //                                     description: fas.description.content,
        //                                     class: 'fas fa-dumbbell'
        //                                 });
        //                             }
        //                             if (fas.facilityCode == 320 && fas.facilityGroupCode == 70) {
        //                                 vm.fasPrimaryFront.push({
        //                                     hotelcode: hotel.code,
        //                                     description: fas.description.content,
        //                                     class: 'fas fa-parking'
        //                                 });
        //                             }
        //                         });
        //                     }
        //                 }
        //             });


        //             timeService.init({
        //                 end: function () {
        //                     vm.timeExpired = true;
        //                     vm.showModalMap = false;
        //                 },
        //                 limit: 30
        //             });

        //             var availability = response.data.hotels;

        //             if (typeof response.data.search.filters !== 'undefined') {
        //                 var categories = [];
        //                 if (typeof response.data.search.filters.minCategory !== 'undefined' && typeof response.data.search.filters.maxCategory !== 'undefined') {
        //                     categories = vm.range(parseInt(response.data.search.filters.minCategory), parseInt(response.data.search.filters.maxCategory));
        //                 } else if (typeof response.data.search.filters.minCategory !== 'undefined') {
        //                     // categories = vm.range(parseInt(response.data.search.filters.minCategory), 5);
        //                     categories = vm.range(1, 5);
        //                 } else if (typeof response.data.search.filters.maxCategory !== 'undefined') {
        //                     categories = vm.range(1, parseInt(response.data.search.filters.maxCategory));
        //                 }
        //                 if (categories.length > 0) {
        //                     vm.starFilter.hidden();
        //                     for (var contador = 0; contador < categories.length; contador++) {
        //                         switch (categories[contador]) {
        //                             case 1:
        //                                 vm.starFilter.one.visible = true;
        //                                 if (categories.length == 1) vm.starFilter.one.selected = true;
        //                                 break;
        //                             case 2:
        //                                 vm.starFilter.two.visible = true;
        //                                 if (categories.length == 1) vm.starFilter.two.selected = true;
        //                                 break;
        //                             case 3:
        //                                 vm.starFilter.three.visible = true;
        //                                 if (categories.length > 0) vm.starFilter.three.selected = true;
        //                                 break;
        //                             case 4:
        //                                 vm.starFilter.four.visible = true;
        //                                 if (categories.length == 1) vm.starFilter.four.selected = true;
        //                                 break;
        //                             case 5:
        //                                 vm.starFilter.five.visible = true;
        //                                 if (categories.length == 1) vm.starFilter.five.selected = true;
        //                                 break;
        //                         }
        //                     }
        //                 }
        //             }

        //             var listCodes = [];

        //             for (var i = 0; i < availability.length; i++) {
        //                 listCodes.push(availability[i].code);
        //                 availability[i].rates = 1;
        //                 zonas.push(availability[i].zoneName);
        //             }
        //             vm.viewHoteles = availability;
        //             $scope.numhoteles = availability.length;
        //             //- Este condición nos indica si existen hoteles que se agregaron y no tienen contenido
        //             if (listCodes.length > 0) {

        //             }

        //             if (typeof response.data.search.sort !== 'undefined') {
        //                 var order = 0;
        //                 var sortOption = 0;

        //                 if (typeof response.data.search.order !== 'undefined') {
        //                     if (response.data.search.order == 'DESC') {
        //                         order = 1;
        //                     }
        //                 }

        //                 switch (response.data.search.sort) {
        //                     case 'rate':
        //                         sortOption = 2 + order;
        //                         break;
        //                     case 'category':
        //                         sortOption = 4 + order;
        //                         break;
        //                     default:
        //                         sortOption = 1;
        //                 }

        //             } else {
        //                 vm.filterSelect.selectedOption.id = 1;
        //                 vm.OrdeIn = vm.filterSelect.selectedOption.id;
        //                 $("#ordenamiento").find("option[value='" + vm.filterSelect.selectedOption.id + "']").prop("disabled", true).addClass('select_option');

        //             }

        //             $scope.hbRS = true;
        //     }
        //     vm.hoteles = angular.copy(vm.viewHoteles);
        //     scrollcloseloader(true);
        // }).catch(function (error) {
        //     loader('none');
        // });

        loader('none');

        /* Funciones del scope */
        vm.filterSelectAply = fnfilterSelectAply;
        vm.changeView = fnChangeView;
        vm.setCotizadorData = fnSetCotizadorData;
        vm.press = fnPress;
        vm.showMoreItems = fnShowMoreItems;
        vm.searchFilterReset = fnSearchFilterReset;
        vm.irarriba = fnIrarriba;
        vm.iconocurrency = fnIconocurrency;
        vm.showallItems = fnShowallItems;
        vm.showModalMapRates = fnShowModalMapRates;
        vm.searchkey = fnsearchkey;
        vm.searchhotel = fnsearchhotel;
        vm.eliminaFiltroEstrellas = fneliminaFiltroEstrellas;
        vm.eliminaFiltroRegimen = fneliminaFiltroRegimen;
        vm.eliminaFiltroZone = fneliminaFiltroZone;

        /* Declaracion de las funciones del scope */

        function fnsearchkey(event) {
            if (event.keyCode == 13) {
                if (vm.searchText != '' && vm.searchText.length >= 3) {
                    vm.searchTextTemp = vm.searchText;
                    vm.unirfiltros();
                }
            }
        }

        function fnsearchhotel() {
            if (vm.searchText != '' && vm.searchText.length >= 3) {
                vm.searchTextTemp = vm.searchText;
                vm.unirfiltros();
            }
        }

        function fnSearchFilterReset() {
            vm.searchText = '';
            vm.unirfiltros();
        }
        vm.flag_recomendation = true;

        function fnfilterSelectAply() {
            if(vm.boardFilters.lenght > 0 || vm.searchText.lenght > 2) {
                vm.unirfiltros();
            }
            switch (vm.filterSelect.selectedOption.id) {
                case 1:
                    if (vm.flag_recomendation) {
                        vm.searchText = '';
                        vm.ordenView.type = 1;
                        vm.ordenView.order = 0;
                        vm.flag_recomendation = false;
                        vm.viewHoteles = vm.hoteles;
                        $scope.numhoteles = vm.viewHoteles.length;
                    }

                    vm.changeView(1);
                    disableOption();
                    break;
                case 2:
                    $scope.sortBy('minPackage.avgPrice', false);
                    vm.changeView(1);
                    vm.flag_recomendation = true;
                    disableOption();
                    break;
                case 3:
                    $scope.sortBy('minPackage.avgPrice', true);
                    vm.changeView(1);
                    vm.flag_recomendation = true;
                    disableOption();
                    break;
                case 4:
                    $scope.sortBy('minPackage.avgPrice', false);
                    vm.viewHoteles = $filter('orderByCategoryFilter')(vm.viewHoteles, 'LOWER');
                    vm.changeView(1);
                    vm.flag_recomendation = true;
                    disableOption();
                    break;
                case 5:
                    $scope.sortBy('minPackage.avgPrice', false);
                    vm.viewHoteles = $filter('orderByCategoryFilter')(vm.viewHoteles, 'HIGHER');
                    vm.changeView(1);
                    vm.flag_recomendation = true;
                    disableOption();
                    break;
                default:
                    break;
            }

        }

        function disableOption() {
            var NewOrden = vm.filterSelect.selectedOption.id;

            if (NewOrden != null) {
                $("#ordenamiento").find("option[value='" + vm.OrdeIn + "']").prop("disabled", '').removeClass('select_option');
                $("#ordenamiento").find("option[value='" + NewOrden + "']").prop("disabled", true).addClass('select_option');;
                vm.OrdeIn = NewOrden;
            }
        }
        function fnChangeView(item) {     
            if(item != 1){
                vm.fnFullScreen(item);
                vm.activatedView = item;
                angular.element(vm.views[item -1]).removeClass('d-none d-md-block');
                angular.element(vm.views[0]).addClass('d-none d-md-block');
            }else{
                item = 1;
                vm.fnFullScreen(item);
                angular.element(vm.views[vm.activatedView -1]).addClass('d-none d-md-block');
                angular.element(vm.views[0]).removeClass('d-none d-md-block');
                vm.activatedView = item;
            }        
        }    
        vm.fnFullScreen = function (item) {
            let activatedView = vm.views[item - 1];
            const mainView = '#listaCollapse';
            const quoteView = '#cotizadorCollapse';
            const orderView = '#orderByCollapse';
            const filterView = '#filtros';
            if (activatedView == quoteView || activatedView == orderView || activatedView == filterView){
                $('body').css('background-color', 'rgb(255, 255, 255)');
                if (activatedView == quoteView) 
                document.body.style.backgroundColor = 'rgb(244, 246, 248)';
                else 
                document.body.style.backgroundColor = 'rgb(255, 255, 255)';
                angular.element('.Navbar__container').addClass('d-none d-md-block');
                angular.element('#nav-habitacion').addClass('d-none d-md-block');
                angular.element('#nav-habitacines-menu').addClass('d-none d-md-block');  
            }else{
                $('body').css('background-color', 'rgb(255, 255, 255)');
                angular.element('.Navbar__container').removeClass('d-none d-md-block');
                angular.element('#nav-habitacion').removeClass('d-none d-md-block');
                angular.element('#nav-habitacines-menu').removeClass('d-none d-md-block');
            }
        }

        function fnSetCotizadorData(searchData) {
            vm.initializationData = searchData;
            vm.destination = searchData.destination;
            vm.stay.checkIn = searchData.stay.checkIn;
            vm.stay.checkOut = searchData.stay.checkOut;
            vm.id = searchData.token;
            vm.type = searchData.type;
            vm.totalNoches = moment(searchData.stay.checkOut, 'YYYY-MM-DD').diff(moment(searchData.stay.checkIn, 'YYYY-MM-DD'), 'days');
        }

        function fnShowMoreItems() {

            let lastItem = vm.itemsPerPage;
            let codes = [];

            for (let index = 0; index < vm.viewHoteles.length; index++) {
                const element = vm.viewHoteles[index];
                if (index > lastItem && index < (vm.itemsPerPage + 10)) {
                    codes.push(element.code);
                }
            }
            vm.itemsPerPage += 10;
            setApiContent(codes, vm.viewHoteles.length, ['images', 'acommodationTypeCode', 'facilities']);
            if (vm.itemsPerPage >= $scope.numhoteles) {
                $('#gifLoader').hide();
            }
        }

        function fnPress($event) {

            if ($event.isValid) { // Valid Search Form
                HotelFactory.obtenerHoteles();
            }
        }

        function fneliminaFiltroEstrellas(estrella) {
            switch (estrella) {
                case 2:
                    vm.starFilter.two.selected = false;
                    break;
                case 3:
                    vm.starFilter.three.selected = false;
                    break;
                case 4:
                    vm.starFilter.four.selected = false;
                    break;
                case 5:
                    vm.starFilter.five.selected = false;
                    break;

                default:
                    break;
            }
            vm.unirfiltros();
        }

        function fneliminaFiltroRegimen(id) {
            vm.boardFilters[id].checked = false;
            vm.unirfiltros();
        }

        function fneliminaFiltroZone() {
            vm.zonaSeleccionada = 'Todas';
            vm.unirfiltros();
        }

        function fnUnirfiltros() {

            var searchText = "";

            if (vm.searchText.length > 2) {
                searchText = vm.searchText;
                var buscado = $filter('forName')(vm.hoteles, searchText);
                vm.viewHoteles = buscado;
            } else {

                for (var Regi = 0; Regi < vm.boardFilters.length; Regi++) {

                    if (vm.boardFilters[Regi].boardName == vm.radiostartBoar) {
                        vm.boardFilters[Regi].checked = true;
                        vm.radiostartboardCode = vm.boardFilters[Regi].boardCode;
                    } else {
                        vm.boardFilters[Regi].checked = false;
                    }
                }

                if (vm.hoteles.length == 0) { window.location.reload(true); }

                vm.viewHoteles = $filter('filtrosgral')(
                    vm.hoteles,
                    vm.starFilter,
                    vm.boardFilters,
                    "",
                    vm.zonaSeleccionada,
                    vm.alojamientoSeleccionado
                );

            }
            $scope.numhoteles = vm.viewHoteles.length;
            vm.changeView(1);
            
            if(vm.filterSelect.selectedOption) {
                vm.filterSelectAply();
            }
        }

        $scope.sortBy = function (propertyName, reverse) {
            $scope.propertyName = propertyName;
            vm.viewHoteles = orderBy(vm.viewHoteles, $scope.propertyName, reverse);
        }

        $scope.filterImg = function (roomCode) {
            return function (img) {
                if (img.imageTypeCode === 'HAB' && (img.roomType + '.' + img.characteristicCode) === roomCode) {
                    vm.modalPathActual = img.path;
                    return img;
                }
            };
        };

        function setApiContent(codes, limit, params, limitInf, limitSup) {

            if (typeof limitInf === 'undefined') {
                limitInf = 0;
            }
            if (typeof limitSup === 'undefined') {
                limitSup = 0;
            }
            if (limitInf === 0 && limitSup === 0) {
                limitSup = limit;
            }
            // Bandera para saber si existe imagenes dentro de los parametros de la API

            ContentApiService.get(codes, params).then(function (response) {
                var content = response.data.hotels;
                var arrHotels = [];

                for (var i = limitInf; i < limitSup; i++) {
                    for (var _i = 0; _i < content.length; _i++) {
                        if (vm.viewHoteles[i].code == content[_i].code) {
                            if (angular.isDefined(vm.viewHoteles[i].content)) {
                                $.extend(true, vm.viewHoteles[i].content, content[_i]);
                            } else {
                                vm.viewHoteles[i].content = content[_i];
                            }

                            vm.viewHoteles[i].total_noches = vm.totalNoches;
                            arrHotels.push(vm.viewHoteles[i]);

                            if (vm.viewHoteles[i].hasOwnProperty('content')) {
                                if (vm.viewHoteles[i].content.hasOwnProperty('facilities')) {
                                    angular.forEach(vm.viewHoteles[i].content.facilities, function (fas) {
                                        if (fas.facilityCode == 261) {
                                            vm.fasPrimaryFront.push({
                                                hotelcode: vm.viewHoteles[i].code,
                                                description: fas.description.content,
                                                class: 'fas fa-wifi'
                                            });
                                        }
                                        if (fas.facilityCode == 200 && fas.facilityGroupCode == 71) {
                                            vm.fasPrimaryFront.push({
                                                hotelcode: vm.viewHoteles[i].code,
                                                description: fas.description.content,
                                                class: 'fas fa-utensils'
                                            });
                                        }
                                        if (fas.facilityCode == 470 && fas.facilityGroupCode == 70) {
                                            vm.fasPrimaryFront.push({
                                                hotelcode: vm.viewHoteles[i].code,
                                                description: fas.description.content,
                                                class: 'fas fa-dumbbell'
                                            });
                                        }
                                        if (fas.facilityCode == 320 && fas.facilityGroupCode == 70) {
                                            vm.fasPrimaryFront.push({
                                                hotelcode: vm.viewHoteles[i].code,
                                                description: fas.description.content,
                                                class: 'fas fa-parking'
                                            });
                                        }
                                    });
                                }
                            }

                        }
                    }
                }

                vm.hoteles = angular.copy(vm.viewHoteles);

            }).catch(function (err) {
                console.log(err);
            });
        }

        vm.backToTop = function () {
            $('body,html').animate({
                scrollTop: 0
            }, 700);
            return false;
        }
        var amountScrolled = 100;
        $(window).scroll(function () {
            if ($(window).scrollTop() > amountScrolled) {
                $('a.back-to-top').fadeIn('slow');
            } else {
                $('a.back-to-top').fadeOut('slow');
            }
        });

        function fnChainsInsertion(arrHotels, arrChains) {
            var params = {
                params: {
                    chainCode: arrChains
                }
            };
            HotelFactory.getCadena(params).then(function (response) {
                var chains = response.data;
                angular.forEach(vm.viewHoteles, function (hotel) {
                    angular.forEach(arrHotels, function (hotel_) {
                        if (hotel.code == hotel_.code) {
                            angular.forEach(chains, function (chain) {
                                if (hotel.content.chainCode == chain.code) {
                                    hotel.chain = chain.contenido;
                                }
                            });
                        }
                    });
                });
            });
            vm.hoteles = vm.viewHoteles;
        }

        function fnShowallItems(totalnoches) {
            for (var i = 0; i < vm.hoteles.length; i++) {
                vm.hoteles[i].total_noches = totalnoches;
            }
            vm.showModalMapRates();
        };

        function fnShowModalMapRates() {
            vm.showModalMap = !vm.showModalMap;
        }

        vm.showGalleryFull = function (hotel) {
            configOptions = {
                buttons: [
                    'slideShow',
                    'fullScreen',
                    'thumbs',
                    'close'
                ],
                thumbs: {
                    autoStart: true
                }
            };

            obj = vm.galleryOpeneds.find(element => element.hotelcode == hotel.code);
            if (obj == undefined) {
                $.fancybox.open({
                    src: '',
                    type: 'html',
                    smallBtn: false
                });
                $.fancybox.getInstance().showLoading(0);
                ContentApiService
                    .get([hotel.code], ['images'])
                    .then((response) => {
                        console.log(hotel.code);
                        vm.galleryOpeneds.push({
                            hotelcode: hotel.code,
                            images: response.data.hotels[0].images
                        });
                        imgsFancy = createObjGallery(response.data.hotels[0].images);
                        $.fancybox.getInstance().close();
                        $.fancybox.open(imgsFancy, configOptions);
                    });
            } else {
                imgsFancy = createObjGallery(obj.images);
                $.fancybox.open(imgsFancy, configOptions);
            }
        }

        createObjGallery = function (imgs) {
            imagesObj = [];
            angular.forEach(imgs, function (img) {
                imagesObj.push({
                    src: vm.pathImagesBigger + '/' + img.path,
                    opts: {
                        thumb: vm.pathImages + '/' + img.path
                    }
                });
            });
            return imagesObj;
        }

        vm.loadTab = function (index, hotel) {

            if (hotel.code != vm.selectedHotel) {
                vm.tabs = [false, false, false, false];
            }

            vm.selectedHotel = hotel.code;

            if (index != this.tabSelected) {
                if (this.tabSelected >= 0) this.tabs[this.tabSelected] = false;
                this.tabSelected = index;
            }

            this.tabs[index] = !this.tabs[index];

            if (index == 0 && this.tabs[index]) {
                ContentApiService
                    .get([hotel.code], ['images'])
                    .then((response) => {
                        angular.extend(hotel.content.images, response.data.hotels[0].images);
                        vm.imageGroup(hotel);
                    });
            }

            if (index == 1 && this.tabs[index]) {
                ContentApiService
                    .get([hotel.code], ['interestPoints'])
                    .then((response) => {
                        if (angular.isDefined(response.data.hotels[0].interestPoints)) {
                            hotel.content.interestPoints = [];
                            angular.extend(hotel.content.interestPoints, response.data.hotels[0].interestPoints);
                        }
                    });
            }

            if (index == 3 && this.tabs[index]) {
                ContentApiService
                    .get([hotel.code], ['description'])
                    .then((response) => {
                        if (angular.isDefined(response.data.hotels[0].description)) {
                            hotel.content.description = response.data.hotels[0].description;
                        }
                    });
            }
        }

        vm.hotelSelected = function (clickEvent, hotel) {

            var query = '';
            var hBack = angular.copy(hotel);

            if (typeof hBack.packageGrouped !== 'undefined') {
                var setter = false;
                angular.forEach(hBack.packageGrouped, function (group) {
                    angular.forEach(group, function (_package) {
                        angular.forEach(vm.boardFilters, function (bo) {
                            if (bo.checked) {
                                query = _package.boardCode;
                                setter = true;
                            }
                        });
                    });
                    if (!setter) {
                        query = 'ALL';
                    }
                });
                // delete hBack.packageGrouped;
            }

            if (HotelFactory.isLocalStorageAvailable()) {
                localStorage.setItem('hotelSelected', JSON.stringify(hBack));

                searches = localStorage.getItem('searches') == null || localStorage.getItem('searches').length == 0 ? [] : JSON.parse(localStorage.getItem('searches'))

                if (searches.find(element => element.hotel.code == hBack.code) === undefined) {
                    if (searches.length >= 3) {
                        searches.shift();
                    }
                    searches.push({
                        hotel: hBack,
                        search: JSON.parse(localStorage.getItem('search'))
                    });
                    localStorage.setItem('searches', JSON.stringify(searches));
                }
            }

            let target = ($('#target').val() == '1') ? '_blank' : '_self';
            window.open('/hotel/details/' + hotel.tokenName + '?flt=' + query, target);

        }

        vm.imageGroup = function (hotel) {
            var imagenes = [];

            vm.codeHotel = hotel.code;
            if (hotel.content.images) {
                hotel.fotoActual = hotel.content.images[0].path;
                var limSup = hotel.content.images.length;
                for (var __i = 0; __i < limSup; __i++) {
                    imagenes.push((/^\/.+$/.test(hotel.content.images[__i].path) ? hotel.content.images[__i].path : '/' + hotel.content.images[__i].path));
                }
                vm.imgApihotel = hotel.content.images;
                hotel.imagenes = imagenes;
                Array.prototype.unique = function (a) {
                    return function () {
                        return this.filter(a)
                    };
                }(function (a, b, c) {
                    return c.indexOf(a, b + 1) < 0;
                });
                hotel.imagenes = hotel.imagenes.unique();
            }
        }

        vm.fnIconocurrency = function (hotel) {

            switch (hotel.currency) {
                case 'USD':
                    hotel.iconocurrency = '$';
                    break;
                case 'EUR':
                    hotel.iconocurrency = '€';
                    break;
                case 'GBP':
                    hotel.iconocurrency = '£';
                    break;
                default:
                    hotel.iconocurrency = '$';
                    break;
            }

        }

        function scrollcloseloader($list = false) {
            if ($list == true) {
                // vm.unirfiltros();                
                // vm.eliminaFiltroEstrellas();
                vm.filterSelectAply();
            }

            if (!$scope.hbRS) {
                var ubicacion = $("#scrollcloseloader").offset();
                $('body, html').animate({
                    scrollTop: (ubicacion.top) + 'px'
                }, 700);
            } else if (!$scope.hbRS) {
                var ubicacion = $("#scrollcloseloader").offset();
                $('body, html').animate({
                    scrollTop: (ubicacion.top) + 'px'
                }, 700);
            } else if ($scope.hbRS) {
                var ubicacion = $("#scrollcloseloader").offset();
                $('body, html').animate({
                    scrollTop: (ubicacion.top + 200) + 'px'
                }, 700);
            } else if ($scope.hbRS) {
                var ubicacion = $("#scrollcloseloader").offset();
                $('body, html').animate({
                    scrollTop: (ubicacion.top + 300) + 'px'
                }, 700);
            } else {
                var ubicacion = $("#scrollcloseloader").offset();
                $('body, html').animate({
                    scrollTop: (ubicacion.top + 305) + 'px'
                }, 700);
            }
        }

        function fnIrarriba() {
            $('body, html').animate({
                scrollTop: '0px'
            }, 700);
        }

        function alertMsg(msg) {
            $('#alertContainer').html('<div class="alert alert-warning alert-dismissible" role="alert">' + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' + '<span aria-hidden="true">&times;</span>' + '</button>' + msg + '</div>');
        }

        function loader(type) {
            vm.loaderStyle = { display: type }
        }

        function fnIconocurrency(currency) {
            $scope.iconocurrency = CurrencyDictionary[currency];;
        }

        vm.range = function (start, end) {
            var result = [];
            while (start <= end) {
                result.push(start);
                start++;
            }
            return result;
        }
        var p = this;

        var $window = $(window),
            previousScrollTop = 0,
            scrollLock = true;
        $window.scroll(function (event) {
            if (vm.itemsPerPage <= $scope.numhoteles) {
                if (scrollLock) {

                    if ($(window).scrollTop() >= $('#listaCollapse').offset().top + $('#listaCollapse').outerHeight() - window.innerHeight - 1) {

                        event.preventDefault();
                        $('#gifLoader').show();
                        scrollLock = false;
                        setTimeout(() => {
                            p.showMoreItems();
                            scrollLock = true;
                        }, 500);
                    }
                }
            } else {
                $('#gifLoader').hide();
            }
        });

    }
})();